export default "__VITE_ASSET__hO6MAiby__"